/**
 * api接口统一管理
 */
import { post } from '@/request/http'

// 用户登录
export const apiLogin = p => post('/user/login', p)
// 退出登录
export const apiSignOut = p => post('/user/signOut', p)
// 用户注册or用户信息编辑
export const apiAddUser = p => post('/user/addUser', p)
// 删除用户信息
export const apiDelUser = p => post('/user/delUser', p)
// 查询全部用户
export const apiUserFindAll = p => post('/user/findAll', p)
/**
 * 文章管理
 */
// 查询全部导航栏
export const apiNavigationFindAll = p => post('/navigation/findAll', p)
// 根据id查询导航栏数据
export const apiNavigationFindById = p => post('/navigation/findById', p)
// 添加or编辑导航栏
export const apiAddNavigation = p => post('/navigation/addNavigation', p)
// 彻底删除导航栏
export const apiRemoveNavigation = p => post('/navigation/removeNavigation', p)
// 按条件查询全部文章
export const apiArticleFindAll = p => post('/article/findAll', p)
// 添加or编辑文章
export const apiAddArticle = p => post('/article/addArticle', p)
// 删除文章
export const apiDelArticle = p => post('/article/delArticle', p)
/**
 * 预约管理
 */
// 查询全部预约挂号
export const apiReservationFindAll = p => post('/reservation/findAll', p)
// 删除预约挂号
export const apiDelReservation = p => post('/reservation/delReservation', p)
// 添加or修改预约挂号
export const apiAddReservation = p => post('/reservation/addReservation', p)
// 根据手机号查询预约挂号
export const apiReservationFindByTel = p => post('/reservation/findByTel', p)
